<template>
    <div
         @click="btnClicked"
    >
        <div class="icon-zurueck" :class="{'is-clicked': zurueckBtnClicked}" @animationend="iconAnimationEnd">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" class="svg-inline--fa fa-chevron-left fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="#333333" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path></svg>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'zurueck-button',
        props: {
            clickHandler: Function,
        },
        data() {
            return {
                zurueckBtnClicked: false,
            }
        },
        methods: {
            btnClicked() {
                this.clickHandler();
                this.zurueckBtnClicked = true;
            },
            iconAnimationEnd($event) {
                this.zurueckBtnClicked = false;
            }
        }
    }

</script>

<style lang="scss" scoped>

    .zurueck-btn {
        position: absolute;
        top: calc(100% - 25px);
        left: calc(50% - 120px);
        bottom: auto;
        align-items: center;
        background-color: #FFFFFF;
        border-radius: 50%;
        width: 50px;
        height: 50px;
        text-align: center;
        z-index: 1;
        cursor: pointer;
        box-shadow: 0px 1px 20px 5px rgba(0, 0, 0, 0.3);
        opacity: 0;
        transition: opacity 400ms ease-in-out;
        transition-delay: 800ms;

        &.anzeigen {
            opacity: 1;
        }

        .icon-zurueck {
            width: 15px;
            height: 24px;
            top: 50%;
            position: absolute;
            left: 50%;
            transform: translate(-50%, -50%);

             &.is-clicked {
                animation: icon-links 500ms ease-in-out;
            }
        }
    }

    @keyframes icon-links {
        0% {
            transform: translate(-50%, -50%);
        }

        50% {
            transform: translate(-100%, -50%);
        }

        100% {
            transform: translate(-50%, -50%);
        }
    }

</style>